import React, { useState, useEffect, useContext } from 'react';

import { MobileContext } from 'context';
//import DogeClock from 'assets/Clock.svg';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClock } from '@fortawesome/free-solid-svg-icons';
import './timer.scss';


function RoundTimer(props) {
  const isMobile = useContext(MobileContext);
  const [targetTimestamp, SetTargetTime] = useState(props.targetTimestamp * 1000);
  const [remainingTime, SetRemainingTime] = useState(0);

  useEffect(() => {
    //const timeout = setTimeout(Update, 450);
    Update();
    const timer = setInterval(Update, 1000);
    return () => {
      //clearTimeout(timeout);
      clearInterval(timer);
    };
  }, [targetTimestamp]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    Reset();
    //Update();
  }, [props.targetTimestamp]); // eslint-disable-line react-hooks/exhaustive-deps


  function Reset() {
    const jsTimestamp = props.targetTimestamp * 1000;
    const currentTimestamp = Date.now();
    const millisecondsLeft = jsTimestamp - currentTimestamp;
    SetTargetTime(props.targetTimestamp * 1000);
    SetRemainingTime(millisecondsLeft);
  }

  function Update() {
    const currentTimestamp = Date.now();
    const millisecondsLeft = targetTimestamp - currentTimestamp;
    SetRemainingTime(millisecondsLeft);
  }

  function TimeLeftFormatted() {
    if (remainingTime < 0)
      return props.endedMessage;
    const secondsLeftTotal = Math.round(remainingTime / 1000);
    const minutesLeft = Math.floor(secondsLeftTotal / 60);
    let secondsLeft = secondsLeftTotal - Math.abs(minutesLeft * 60);
    if (secondsLeft < 10) secondsLeft = '0' + secondsLeft;
    return (
      <React.Fragment>
        {/* {props.ongoingMessage} in {minutesLeft} */}
        {props.ongoingMessage} {minutesLeft}
        <span className='timeSeparators'> m:</span>
        {secondsLeft}
        <span className='timeSeparators'> s</span>
      </React.Fragment>
    );
  }

  if (targetTimestamp && remainingTime)
    return (
      <div className={'ThemeBox TimerContainer' + (isMobile ? ' Mobile' : ' ') }>
        {props.showImage ? (
          /*<img alt='timer' className='Old DogeClock' src={DogeClock} /> */
          <FontAwesomeIcon className='DogeClock' icon={faClock} size='1x' />
        ) : null}
        <p>{TimeLeftFormatted()}</p>
      </div>
    );
  else
    return (<div className={'ThemeBox TimerContainer Blank' + (isMobile ? ' Mobile' : ' ') }></div>);
}

export default RoundTimer;
